import React from "react";
import moment from "moment";
import ParagraphTag from "../../reusebale/Paragraph";
import db from "../../../db/index.json";

const Subscriptions = ({ onViewAll, recentSubscriptions }) => {
  const { rightPanel } = db;

  return (
    <div className="bg-white rounded-2xl py-5 px-4 w-full mt-5 shadow-md shadow-gray-200 transition-all duration-300 hover:opacity-90">
      <div className="flex justify-between items-center">
        <ParagraphTag
          content={rightPanel.recentSubscription}
          classes="text-darkColor font-popinsSemiBold text-base"
        />
        <ParagraphTag
          content={rightPanel.viewall}
          classes="text-themeColor font-popinsSemiBold text-xs cursor-pointer"
          onTrigger={onViewAll}
        />
      </div>

      {/* Header */}
      <div className="flex border-b border-darkColor/20 pb-2 mt-6">
        <div className="w-[25%]">
          <p className="text-darkColor/40 font-popinsMedium text-xs">{rightPanel.landlords}</p>
        </div>
        <div className="w-[22%]">
          <p className="text-darkColor/40 font-popinsMedium text-xs">{rightPanel.package}</p>
        </div>
        <div className="w-[13%] text-center">
          <p className="text-darkColor/40 font-popinsMedium text-xs">{rightPanel.invoice}</p>
        </div>
        <div className="w-[13%] text-center">
          <p className="text-darkColor/40 font-popinsMedium text-xs">Amount</p>
        </div>
        <div className="w-[27%] text-end">
          <p className="text-darkColor/40 font-popinsMedium text-xs">{rightPanel.expiry}</p>
        </div>
      </div>

      {/* Rows */}
      {recentSubscriptions && recentSubscriptions.length > 0 ? (
        recentSubscriptions.map((item, i) => (
          <div key={item.landlordId || i} className="flex items-center py-2.5 border-b border-gray-50">
            <div className="w-[25%] pr-2">
              <p className="text-darkColor font-popinsSemiBold text-sm truncate">{item.landlordName}</p>
              <p className="text-darkColor/40 font-popinsRegular text-xs truncate">{item.landlordEmail || ""}</p>
            </div>
            <div className="w-[22%] pr-2">
              <p className="text-themeColor font-popinsMedium text-xs leading-tight">
                {item.defaultPackageName}
              </p>
            </div>
            <div className="w-[13%] text-center">
              <p className="text-darkColor font-popinsMedium text-sm">
                {["active", "expired"].includes(item.status) ? item.invoiceId : "—"}
              </p>
            </div>
            <div className="w-[13%] text-center">
              <p className="text-darkColor font-popinsMedium text-sm">
                ${item.subscriptionAmount || "0.00"}
              </p>
            </div>
            <div className="w-[27%] text-end">
              <p className="text-darkColor/60 font-popinsRegular text-xs">
                {moment(item.dateOfExpiry).format("MM/DD/YY")}
              </p>
            </div>
          </div>
        ))
      ) : (
        <div className="flex justify-center items-center py-8">
          <p className="text-darkColor/40 font-popinsMedium text-sm">No recent subscriptions found</p>
        </div>
      )}
    </div>
  );
};

export default Subscriptions;
